export default {
	methods: {
		excluirModal(configs, data) {
			let ok, not;
			this.OK = function (callback) {
				ok = callback;
				return this;
			};
			this.Not = function (callback) {
				not = callback;
				return this;
			};
			this.$bvModal
				.msgBoxConfirm(configs.message + "?", {
					title: configs.title,
					okVariant: configs.primary ? "primary" : "danger",
					okTitle: configs.okTitle,
					cancelVariant: "outline-info",
					cancelTitle: configs.cancelTitle,
					footerClass: "border-top-0",
					size: "402px",
					centered: configs.centered
				})
				.then((value) => {
					if (typeof ok == "function" && value) {
						ok(data);
					} else {
						if (typeof not === "function" && !value) {
							not();
						}
					}
				});
			return this;
		}
	}
};
